module.exports = __webpack_public_path__ + "static/img/6.a5b5461.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/eng/6.png
// module id = nAr5
// module chunks = 0